import React from "react";
import BetOption from "../../../video/video_room/widgets/components/bet_option";
import {attributesToProps, domToReact} from "html-react-parser";

const RenderedBetOption = ({node, options}) => {
  const props = attributesToProps(node.attribs);

  if (!node.attribs["data-bet-id"]) {
    return <div className={"alert alert-danger"}>
      video-room-bet-answer needs a data-bet-id set
    </div>
  }

  if (!node.attribs["data-bet-option"]) {
    return <div className={"alert alert-danger"}>
      video-room-bet-answer needs a data-bet-option set
    </div>
  }

  return <BetOption
    betId={node.attribs["data-bet-id"]}
    option={node.attribs["data-bet-option"]}
    customProps={props}
  >
    {domToReact(node.children, options)}
  </BetOption>;
}

export default RenderedBetOption